import Vue from 'vue';
import VueRouter from 'vue-router';
import firebase from 'firebase/app';
import 'firebase/auth';
import SocialSharing from 'vue-social-sharing';
import Home from '../views/Home.vue';
Vue.use(SocialSharing);

Vue.use(VueRouter);

const routes = [{
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/information/About.vue'),
  },
  {
    path: '/who-behind',
    name: 'who-behind',
    component: () => import('../views/information/WhoBehind.vue'),
  },
  {
    path: '/disclaimer',
    name: 'disclaimer',
    component: () => import('../views/information/Disclaimer.vue'),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login.vue')
  },
  
  {
    path: '/login/success',
    name: 'LoginSuccess',
    component: () => import('../views/LoginSuccess.vue')
  },
  {
    path: '/donation/companies',
    name: 'donation-companies',
    meta: {
      requiresAuth: true
    },
    component: () => import('../views/donation/companies/Companies.vue'),
    children: [{
        path: 'list',
        name: 'donation-companies-list',
        meta: {
          requiresAuth: true
        },
        component: () => import('../views/donation/companies/CompaniesList.vue')
      },
      {
        path: 'create',
        name: 'donation-companies-create',
        meta: {
          requiresAuth: true
        },
        component: () => import('../views/donation/companies/CompanyCreate.vue')
      }
    ]
  },

  {
    path: '/donation/companies/:companyId',
    name: 'donation-companies-company',
    meta: {
      requiresAuth: true
    },
    props: true,
    component: () => import('../views/donation/companies/company/Company.vue'),
    children: [{
      path: 'donate',
      name: 'donation-companies-company-donate',
      props: true,
      component: () => import('../views/donation/companies/company/CompanyDonation.vue'),
      meta: {
        requiresAuth: true
      }
    }, ]
  },

  {
    path: '/companies',
    name: 'companies',
    component: () => import('../views/companies/Companies.vue'),
    children: [{
        path: 'list',
        name: 'companies-list',
        component: () => import('../views/companies/CompaniesList.vue')
      },
      {
        path: 'create',
        name: 'companies-create',
        component: () => import('../views/companies/CompanyCreate.vue')
      },
      {
        path: 'thanks',
        name: 'company-thanks',
        component: () => import('../views/companies/CompanyThanks.vue'),
      }
    ]
  },

  {
    path: '/companies/:companyId',
    name: 'companies-companyId',
    props: true,
    component: () => import('../views/companies/company/Company.vue'),
    children: [{
        path: 'detail',
        name: 'companies-companyId-detail',
        component: () => import('../views/companies/company/CompanyDetail.vue'),
        props: true
      },
      {
        path: 'donation/:donationId',
        name: 'companies-companyId-donation-donationId',
        component: () => import('../views/donation/companies/company/CompanyDonationDetail.vue'),
        props: true
      }
    ]
  },
  {
    path: '/user',
    name: 'user',
    meta: {
      requiresAuth: true
    },
    component: () => import('../views/user/User.vue'),
    children: [{
      path: 'profile',
      name: 'user-profile',
      component: () => import('../views/user/UserDetail.vue'),
      meta: {
        requiresAuth: true
      }
    }],
  },

  {
    path: '/demo/23452123545341231/lang',
    name: 'demo-23452123545341231-lang',
    component: () => import('../views/demo/lang/DemoLang.vue')
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior () {
    return { x: 0, y: 0 };
  }
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth);
  const currentUser = firebase.auth().currentUser;
  document.title = 'COVIDA';

  if (requiresAuth && !currentUser) {
    next('/login');
  } else if (requiresAuth && currentUser) {
    next();
  } else {
    next();
  }
})

export default router;